import React from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import Logo from '../../../components/Logo';
import SideMenuSection from './SideMenuSection';
import {
	getDashboardSideMenu, getUsersSideMenu, getConfigurationSideMenu,
	getAdminConfigSideMenu, getCarSettingsMenu, getCarsMenu, getReservationMenu,
	getContentPageMenu, announcementSideMenu
} from '../../../helpers/getSideMenuData';
import sayIcon from '../../../../public/sayIcon.png'
import s from './SideBar.css';
import messages from '../../../locale/jsonMessages';

function SideBar(props) {
	const { handleMobileMenu, location, isSuperAdmin, privileges, logoImage, isPromoCodeEnabled, isServicePlanEnabled } = props;
	const intl = useIntl();

	const sideMenu = [
		{ menuData: getDashboardSideMenu, label: null },
		{ menuData: getConfigurationSideMenu, label: intl.formatMessage(messages.configurations) },
		{ menuData: getAdminConfigSideMenu, label: intl.formatMessage(messages.adminConfigurations) },
		{ menuData: getUsersSideMenu, label: intl.formatMessage(messages.usersLabel) },
		{ menuData: getCarSettingsMenu, label: intl.formatMessage(messages.carSettingsForStep) },
		{ menuData: getCarsMenu, label: intl.formatMessage(messages.cars) },
		{ menuData: getReservationMenu, label: intl.formatMessage(messages.reservationMenu) },
		{ menuData: announcementSideMenu, label: intl?.formatMessage(messages.announcementSideMenu) },
		{ menuData: getContentPageMenu, label: intl.formatMessage(messages.contentPages) },
	];

	return (
		<div className={s.sideMenuContent}>
			<div className={s.sideMenuHeader}>
				<div className={cx(logoImage && s.sideMenuHeaderLogoContainer)}>
					<Logo link={"/siteadmin"} className={cx(logoImage ? s.sideMenuHeaderLogoContainer : s.sideMenuHeaderLogoText)} />
				</div>
				<span className={s.sideMenuHeaderTextContainer}>
					<img src={sayIcon} alt="sayIcon" />
					<FormattedMessage  {...messages.welcomeAdminLabel} />
				</span>
			</div>
			<div className={s.sideMenuBody}>
				{sideMenu?.map((item, key) => {
					return (
						<SideMenuSection
							key={key}
							handleMobileMenu={handleMobileMenu}
							menuData={item?.menuData}
							label={item?.label}
							location={location}
							isSuperAdmin={isSuperAdmin}
							privileges={privileges}
							isPromoCodeEnabled={isPromoCodeEnabled}
							isServicePlanEnabled={isServicePlanEnabled}
						/>
					)
				})}
			</div>
		</div>
	)
}

const mapState = (state) => ({
	isSuperAdmin: state.runtime.isSuperAdmin,
	privileges: state.account.privileges && state.account.privileges.privileges && state.account.privileges.privileges,
	logoImage: state?.siteSettings?.data?.Logo,
	isPromoCodeEnabled: state?.siteSettings?.data?.isPromoCodeEnabled,
	isServicePlanEnabled: state?.siteSettings?.data?.isServicePlanEnabled
});

const mapDispatch = {
};

export default withStyles(s)(connect(mapState, mapDispatch)(SideBar));